import { render, staticRenderFns } from "./shift-penalty.vue?vue&type=template&id=26d9a26e&scoped=true"
import script from "./shift-penalty.vue?vue&type=script&lang=js"
export * from "./shift-penalty.vue?vue&type=script&lang=js"
import style0 from "./shift-penalty.vue?vue&type=style&index=0&id=26d9a26e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d9a26e",
  null
  
)

export default component.exports